import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Row from "./Row";
import { drawingCols } from "./utils";
import { Box, Button } from "@mui/material";
import { DrawingBomContext } from "../../../DrawingBomContext";
import { useBOMDashboardContext } from "../../../../BOMDashboard.context";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadablePage from "../../../../../../../../../../components/DownloadablePage";

const btnStyle = { mx: 0.4, my: 0.5, flexGrow: 1 };

export default function DrawingBomTable() {
  const {
    removeSelectedDrawing,
    selectionMaterials,
    setSelectionMaterials,
    onRemoveAll,
  } = React.useContext(DrawingBomContext);

  const { project } = useBOMDashboardContext();
  const selectedDrawings = project?.selectedDrawings || [];

  return (
    <DownloadablePage fileName="Drawings.pdf">
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow sx={{}}>
              <TableCell>
                {" "}
                <Button
                  variant="contained"
                  className="no-export"
                  color="error"
                  startIcon={<DeleteIcon />}
                  sx={btnStyle}
                  onClick={onRemoveAll}
                  size="small"
                  disabled={selectedDrawings?.length === 0}
                >
                  Remove All
                </Button>
              </TableCell>
              {drawingCols.map((col) => {
                return (
                  <TableCell
                    key={col.label}
                    sx={{
                      fontweight: 700,
                      fontSize: "17px",
                    }}
                  >
                    {col.label}
                  </TableCell>
                );
              })}
              <TableCell
                sx={{
                  fontweight: 700,
                  fontSize: "17px",
                  textAlign: "center",
                }}
              >
                Doc
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {selectedDrawings.map((row, index) => (
              <Row
                key={row.id}
                index={index}
                row={row}
                removeSelectedDrawing={removeSelectedDrawing}
                selectionMaterials={selectionMaterials}
                setSelectionMaterials={setSelectionMaterials}
              />
            ))}
          </TableBody>
        </Table>
        {!selectedDrawings[0] && (
          <Box sx={{ textAlign: "center", p: 4, color: "#aaa" }}>
            No Drawing is Selected yet. Please, Add Some Drawing.
          </Box>
        )}
      </TableContainer>
    </DownloadablePage>
  );
}
